function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNovaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 324 324"
    },
    viewBox: "0 0 324 324",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 8.15,
    cy: 19.93,
    r: 372.636,
    gradientTransform: "matrix(1 0 0 -1 0 326)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.053,
    style: {
      stopColor: "#d7d3e9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    style: {
      stopColor: "#a19cde"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.383,
    style: {
      stopColor: "#696bd9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#3a5ae7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    style: {
      stopColor: "#225fe7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0883d1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.1 0h155.8C286.3 0 324 37.7 324 84.1v155.8c0 46.5-37.7 84.1-84.1 84.1H84.1C37.7 324 0 286.3 0 239.9V84.1C0 37.7 37.7 0 84.1 0z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 166.7v3c-18.4 2.9-58 9.8-77.5 17.2-7 2.7-12.5 8.1-15.2 15.1-7.4 19.4-14.4 59.2-17.3 77.7h-6c-2.9-18.5-9.9-58.4-17.3-77.7-2.7-6.9-8.2-12.4-15.2-15.1-19.5-7.5-59-14.3-77.5-17.2v-6c18.4-2.9 58-9.8 77.5-17.2 7-2.7 12.5-8.1 15.2-15.1 7.5-19.4 14.4-59.2 17.3-77.7h6c2.9 18.5 9.9 58.3 17.3 77.7 2.7 6.9 8.2 12.4 15.2 15.1 19.5 7.4 59.1 14.3 77.5 17.2v3z",
    style: {
      fill: "#fff"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovaLogo);
export default __webpack_public_path__ + "static/media/nova-logo.ae08b536.svg";
export { ForwardRef as ReactComponent };